import { render } from "./UpdatePasswordForm.vue?vue&type=template&id=6883b91c&scoped=true&ts=true"
import script from "./UpdatePasswordForm.vue?vue&type=script&lang=ts"
export * from "./UpdatePasswordForm.vue?vue&type=script&lang=ts"

import "./UpdatePasswordForm.vue?vue&type=style&index=0&id=6883b91c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6883b91c"]])

export default __exports__